export const defaultValues = {
  appliedAt: null,
  brandId: null,
  targetGmv: null,
  targetViewsShopee: null,
  targetCtrShopee: null,
  targetCtorShopee: null,
  targetAovShopee: null,
  targetViewsTiktok: null,
  targetCtrTiktok: null,
  targetCtorTiktok: null,
  targetAovTiktok: null,
  targetErrTiktok: null,
};
